module.exports = __webpack_public_path__ + "img/accessory_shoe_03.80d8c224.svg";